<template>
  <div class="cashflow-type-variable-expense card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="variableExpenses.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="variableExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="true"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :categories="variableExpenses.monthly.realExpenses.categories"
                                 :expense-category="titles.expenseCategory"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :title="titles.categorySections.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="categoryName"
                                     v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';

export default {
  name: 'CashflowTypeVariableExpense',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.variableExpense;
    },
    variableExpenses() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    categoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.VARIABLE;
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'כמה יצא?',
          recommendedLabel: 'מומלץ היה להוציא עד',
        },
        categorySections: {
          actualsTitle: 'יצא',
          mainTitle: 'פירוט הוצאות משתנות',
        },
        cardTitle: 'הוצאות משתנות',
        expenseCategory: 'משתנות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .past-cashflow-view-container {
    .cashflow-type-variable-expense {
      @include cashflow-card;

      .title {
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_mustard;
      }

      .cashflow-type-background-color {
        background-color: $riseup_mustard;
      }
    }
  }
</style>
